
import Vue from 'vue';
import Component from 'vue-class-component';
import { PropSync } from 'vue-property-decorator';
import PostChallengeForm from './PostChallengeForm.vue';
import PostChallengeSuccess from './PostChallengeSuccess.vue';

@Component({
  components: {
    PostChallengeForm,
    PostChallengeSuccess
  }
})
export default class PostChallengeDialog extends Vue {
  @PropSync('open', { required: true, default: false }) dialog!: boolean;
  succeeded: boolean = false;
}
